import * as e from "react";
import m from "../lib/IconBase.es.js";
import t from "../defs/VideoCamera.es.js";
const o = e.forwardRef((a, r) => /* @__PURE__ */ e.createElement(m, { ref: r, ...a, weights: t }));
o.displayName = "VideoCameraIcon";
const s = o;
export {
  s as VideoCamera,
  o as VideoCameraIcon
};
